export const UNUSE_POINT = 'UNUSE_POINT'
export const UNUSE_POINT_SUCCESS = 'UNUSE_POINT_SUCCESS'
export const UNUSE_POINT_ERROR = 'UNUSE_POINT_ERROR'

export const UnUsePoint = (data) => ({
  type: UNUSE_POINT,
  payload: data
})
